<template>
  <div class="w-180px">
    <a
      href="https://app.zeplin.io/project/5f092773fa16ac9ddd3d2a2f/screen/5f0d0f446f9d538c22f59d59"
      >Form Inputs</a
    >
    <h3>Input</h3>
    <div>
      <div class="form-input-group">
        <span class="prepend-icon"><v-icon>search</v-icon></span>
        <input type="text" class="pl-42px" />
        <span class="append-icon"
          ><v-icon style="transform: rotate(45deg)">add_circle</v-icon></span
        >
      </div>
      <div class="form-input-group success">
        <!-- <span class="prepend-icon"><v-icon>add</v-icon></span> -->
        <input type="text" />
        <span class="append-icon"
          ><v-icon color="success">check_circle</v-icon></span
        >
      </div>
      <div class="form-input-group">
        <!-- <span class="prepend-icon"><v-icon>add</v-icon></span> -->
        <input type="text" />
        <span class="append-icon"
          ><v-icon color="danger-500">warning</v-icon></span
        >
      </div>
      <div class="form-input-group">
        <input type="text" disabled />
      </div>
    </div>

    <h3>TextArea</h3>
    <textarea name="" id="" cols="30" rows="10"></textarea>

    <h3>Search</h3>
    <div class="form-input-group">
      <span class="prepend-icon"><v-icon>search</v-icon></span>
      <input type="text" class="pl-42px" />
      <span class="append-icon"
        ><v-icon style="transform: rotate(45deg)">add_circle</v-icon></span
      >
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
